import { useFormContext } from 'react-hook-form';
import FormSelectField from '../../../formFields/FormSelectField';
import { ppeOptions } from './safetyPlanOptions';
import { withStoredValues } from 'components/IAP/ICSConstants';

const SafetyPlanPpeSection = () => {
  // Stored out-of-vocab values (e.g. agent-written or pre-vocab-alignment entries) render as custom chips.
  const { watch } = useFormContext();
  return (
    <div className="mb-3">
      <FormSelectField
        title="Required Personal Protective Equipment (PPE)"
        fieldName="requiredPpe"
        placeholder="Click to select PPE..."
        options={withStoredValues(
          ppeOptions.map((ppe) => ({ label: ppe, value: ppe })),
          watch('requiredPpe')
        )}
        isMulti={true}
        isClearable={true}
        variant="full"
      />
    </div>
  );
};

export default SafetyPlanPpeSection;
